module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visable) ? _c('div', {
    staticClass: "toast"
  }, [_c('v-touch', {
    staticClass: "toast-mask",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      },
      "tap": _vm.handleMask
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "toast-cont"
  }, [(_vm.type === 'loading') ? _c('i', {
    staticClass: "yxl-font yxl-font-loading520"
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'success') ? _c('i', {
    staticClass: "yxl-font yxl-font-concern"
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'fail') ? _c('i', {
    staticClass: "yxl-font yxl-font-FM51delete"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "toast-text"
  }, [_vm._v(_vm._s(_vm.text))])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7c9d8aa2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Toast.vue
// module id = 2582
// module chunks = 115